import {
  CouponPromotionDetails,
  CouponPromotionDetailsWithAssignmentCounts,
  CouponsApi,
  CreateCouponPromotionRequest,
  GetCouponPromotionRequest,
  GetCouponPromotionsRequest,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getCouponPromotions = async (): Promise<CouponPromotionDetailsWithAssignmentCounts[]> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CouponsApi)

  const request: GetCouponPromotionsRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return (await api.getCouponPromotions(request)).details
}

export type CreateCouponPromotionParams = Omit<CreateCouponPromotionRequest, 'authorization'>

const createCouponPromotion = async (
  createCouponPromotionRequest: CreateCouponPromotionParams,
): Promise<void> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CouponsApi)
  const token = await BackOfficeDataServiceAPI.getAccessToken()
  const request: CreateCouponPromotionRequest = {
    ...createCouponPromotionRequest,
    authorization: `Bearer ${token}`,
  }

  return await api.createCouponPromotion(request)
}

const getCouponPromotion = async (promotionId: string): Promise<CouponPromotionDetails> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CouponsApi)

  const request: GetCouponPromotionRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    promotionId,
  }

  return await api.getCouponPromotion(request)
}

export const CouponServiceAPI = {
  createCouponPromotion,
  getCouponPromotions,
  getCouponPromotion,
}
